import { JSX } from "react"
import { IconButton, Tooltip, Typography } from "@mui/material"
import { ModalMessageContext } from "."
import { ContentCopy } from "@mui/icons-material"

export const SessionModalMessage = {
    'REMOTE_LAUNCH_INITIALIZED': (
        <Typography>
            One minute we are sending the link
        </Typography>
    ),
    'REMOTE_LAUNCH_SUCCESS': (
        <div>
            <Typography>
                SUCCESS!
            </Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                An email with the child's remote launch link was sent to the requested email on file.
            </Typography>
            <Typography sx={{ paddingBottom: "8px" }}>
                The link is good for 2 weeks.
            </Typography>
        </div>
    ),
    'REMOTE_LAUNCH_PARTIAL_SUCCESS': ({ students = [] }: ModalMessageContext) => (
        <div>
            <Typography>Some emails were sent, there was an error with the following</Typography>
            <ul style={{ listStylePosition: "inside" }}>
                {students?.map((student) => (
                    <li>{student?.firstName} {student?.lastName}</li>
                ))}

            </ul>
        </div >
    ),
    'REMOTE_LAUNCH_FAILURE': (
        <div>
            <Typography>Ooops</Typography>
            <Typography>Something went wrong, please try again in a few minutes</Typography>
        </div>
    ),
    'LINK_PREPARED': ({ sessionLink = "" }: ModalMessageContext) => (
        <div>
            <Typography>
                SUCCESS!
            </Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                Here is a link, copy and paste it so you can send it through your own system.
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    wordBreak: "break-all",
                    backgroundColor: "grey.100",
                    padding: "6px 10px",
                    borderRadius: "6px",
                    fontFamily: "monospace"
                }}
            >
                {sessionLink}
            </Typography>
            <Tooltip title="Copy">
                <IconButton size="small" onClick={() => navigator.clipboard.writeText(sessionLink)}>
                    <ContentCopy fontSize="small" />
                </IconButton>
            </Tooltip>
        </div >
    ),
    'PARENT_SEND_GENERAL_INFORMATION_SUCCESS': (
        <div>
            <Typography>
                SUCCESS!
            </Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                The general information email has been sent
            </Typography>
        </div>
    ),
    "TRIAGE_GENERATION_INITIALIZED": (
        <div>
            <Typography>
                One minute, we are making the report
            </Typography>
        </div>
    ),
    "UNREAD_TRIAGE_GENERATION_INITIALIZED": (
        <div>
            <Typography>
                One minute, we are making the report of the children in Actions Needed
            </Typography>
        </div>
    ),
    "TRIAGE_NO_SESSIONS_FOUND": (
        <div>
            <Typography>
                Error, no completed sessions were found with the given infomration, please select a new search parameter.
            </Typography>
        </div>
    ),
}
